import React, { useState } from "react";
import { Button, Icon, Popup, Table } from "semantic-ui-react";
import { Role } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { BasicModal, ConfirmDialog } from "../../../Shared";
import { RoleForm } from "../RoleForm";
import { useLanguage } from "../../../../contexts";
import { isMaster } from "../../../../utils/checkPermission";

const roleController = new Role();

export function RoleItem(props) {
  const { role, onReload } = props;
  const { accessToken, user: { role: userRole } } = useAuth();

  const [showModal, setShowModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  const [isDelete, setIsDelete] = useState(false);

  const { translations } = useLanguage();
  const t = (key) => translations[key] || key;

  const canEdit = isMaster(userRole);

  const onOpenCloseModal = () => setShowModal((prev) => !prev);
  const onOpenCloseConfirm = () => setShowConfirm((prev) => !prev);

  const openUpdateRole = () => {
    setTitleModal(`${t("update")} ${role.name}`);
    onOpenCloseModal();
  };

  const openDesactivateActivateConfim = () => {
    setIsDelete(false);
    setConfirmMessage(
      role.active
        ? `${t("inactive_role")} ${role.name}`
        : `${t("active_role")}${role.name}`
    );
    onOpenCloseConfirm();
  };

  const onActivateDesactivate = async () => {
    try {
      await roleController.updateRole(accessToken, role._id, { active: !role.active });
      onReload();
      onOpenCloseConfirm();
    } catch (error) {
      console.error(error);
    }
  };

  const openDeleteConfirm = () => {
    setIsDelete(true);
    setConfirmMessage(`${t("delete_role")} ${role.name}`);
    onOpenCloseConfirm();
  };

  const onDelete = async () => {
    try {
      await roleController.deleteRole(accessToken, role._id);
      onOpenCloseConfirm();
      onReload();
    } catch (error) {
      onOpenCloseConfirm();
    }
  };

  return (
    <>
      <Table.Row>
        <Table.Cell>{role.name}</Table.Cell>
        <Table.Cell>
          {canEdit && (
            <>
              <Popup
                content={t("edit")}
                trigger={
                  <Button icon primary onClick={openUpdateRole}>
                    <Icon name="pencil" />
                  </Button>
                }
              />
              <Popup
                content={role.active ? t("deactivate") : t("activate")}
                trigger={
                  <Button
                    icon
                    color={role.active ? "orange" : "teal"}
                    onClick={openDesactivateActivateConfim}
                  >
                    <Icon name={role.active ? "ban" : "check"} />
                  </Button>
                }
              />
              <Popup
                content={t("delete")}
                trigger={
                  <Button icon color="red" onClick={openDeleteConfirm}>
                    <Icon name="trash" />
                  </Button>
                }
              />
            </>
          )}
        </Table.Cell>
      </Table.Row>

      <BasicModal show={showModal} close={onOpenCloseModal} title={titleModal} size="tiny">
        <RoleForm onClose={onOpenCloseModal} onReload={onReload} role={role} />
      </BasicModal>

      <ConfirmDialog
        open={showConfirm}
        title={isDelete ? "Eliminar" : (role?.active ? "Desactivar" : "Activar")}
        message={confirmMessage}
        onCancel={onOpenCloseConfirm}
        onConfirm={isDelete ? onDelete : onActivateDesactivate}
        confirmLabel="Aceptar"
        cancelLabel={t("cancel")}
        confirmDanger={isDelete}
      />
    </>
  );
}
